// frontend/hooks/useTrashActions.ts

import { useState, useCallback } from "react";
import { addToDeadLinks } from "../utils/documentUtils";
import { authHeaders, authOnlyHeaders } from "../utils/api";

export interface TrashedDoc {
  id: string;
  title: string;
  icon?: string | null;
  workspaceType: string;
  ownerId: string;
  accessDept: string | null;
  parentId?: string | null;
  updatedBy?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  trashExpiresAt?: string | null;
  isAdminTrash?: boolean;
}

export const useTrashActions = (user: any, apiUrl: string) => {
  const [trashedDocs, setTrashedDocs] = useState<TrashedDoc[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchTrash = useCallback(async () => {
    if (!user) return;
    setIsLoading(true);
    try {
      const res = await fetch(`${apiUrl}/documents/trash/all`, {
        headers: authOnlyHeaders(user?.accessToken),
      });
      const data = await res.json();
      setTrashedDocs(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("휴지통 조회 실패:", err);
    } finally {
      setIsLoading(false);
    }
  }, [apiUrl, user]);

  const handleRestore = async (id: string, e?: React.MouseEvent) => {
    e?.preventDefault();
    try {
      await fetch(`${apiUrl}/documents/${id}/restore`, {
        method: "PATCH",
        headers: authHeaders(user?.accessToken),
        body: JSON.stringify({ requesterId: user?.id, requesterRole: user?.role, requesterDept: user?.department || "" }),
      });
      window.dispatchEvent(new Event("force-sidebar-refresh"));
      fetchTrash();
    } catch {
      alert("복구 실패");
    }
  };

  const handleHardDelete = async (id: string, e?: React.MouseEvent) => {
    e?.preventDefault();
    if (!confirm("정말 영구 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.")) return;
    try {
      const res = await fetch(`${apiUrl}/documents/${id}/hard`, {
        method: "DELETE",
        headers: authOnlyHeaders(user?.accessToken),
      });
      if (res.ok) addToDeadLinks(id);
      window.dispatchEvent(new Event("force-sidebar-refresh"));
      fetchTrash();
    } catch {
      alert("영구 삭제에 실패했습니다.");
    }
  };

  return { trashedDocs, isLoading, fetchTrash, handleRestore, handleHardDelete };
};
